import { GersFullApp } from "./app/apps/FullApp";
import { GersConfigurator } from "./app/apps/configurator";
import { GersCheckout } from "./app/apps/checkout";
import { GersPayment } from "./app/apps/payment";
import { GersStatusAppointment } from "./app/apps/status/appointment";
import { GersStatusPayment } from "./app/apps/status/payment";
import { GersAppointment } from "./app/apps/appointment";
import { GersAppointmentCreated } from "./app/apps/appointment/created";
import { GersSamples } from "./app/apps/samples";
import { GersBusinessConfigurator } from "app/apps/business-configurator";

// @ts-ignore
window.GersConfigurator = GersConfigurator;
// @ts-ignore
window.GersCheckout = GersCheckout;
// @ts-ignore
window.GersPayment = GersPayment;
// @ts-ignore
window.GersStatusAppointment = GersStatusAppointment;
// @ts-ignore
window.GersStatusPayment = GersStatusPayment;
// @ts-ignore
window.GersAppointment = GersAppointment;
// @ts-ignore
window.GersAppointmentCreated = GersAppointmentCreated;
// @ts-ignore
window.GersFullApp = GersFullApp;
// @ts-ignore
window.GersSamples = GersSamples;
//@ts-ignore
window.BusinessConfiguratorApp = GersBusinessConfigurator;
